import { withChartLayout } from 'components/common';
import PhysicalExamination from 'components/features/chart/provider-chart/history-physical/physical-examination/PhysicalExamination';

const PhysicalExaminationPage = withChartLayout('Physical Examination')(PhysicalExamination);
export default PhysicalExaminationPage;
